import React, { useEffect, useState } from 'react';
import '../../Styles/InternshipProgram.css';
import gallery01 from '../../Assets/Internships/Gallery/internship-gallery-01.jpg';
import gallery02 from '../../Assets/Internships/Gallery/internship-gallery-02.jpg';
import gallery03 from '../../Assets/Internships/Gallery/internship-gallery-03.jpg';
import gallery04 from '../../Assets/Internships/Gallery/internship-gallery-04.jpg';
import gallery05 from '../../Assets/Internships/Gallery/internship-gallery-05.jpg';
import gallery06 from '../../Assets/Internships/Gallery/internship-gallery-06.jpg';
import gallery07 from '../../Assets/Internships/Gallery/internship-gallery-07.jpg';
import gallery08 from '../../Assets/Internships/Gallery/internship-gallery-08.jpg';
import gallery09 from '../../Assets/Internships/Gallery/internship-gallery-09.jpg';
import gallery10 from '../../Assets/Internships/Gallery/internship-gallery-10.jpg';

const introductionImages = [
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  gallery05,
  gallery06,
  gallery07,
  gallery08,
  gallery09,
  gallery10,
];

const IntroductionComponent = () => {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = window.setInterval(
      () => setCurrentImage((current) => (current + 1) % introductionImages.length),
      3000,
    );
    return () => window.clearInterval(interval);
  }, []);

  return (
    <div className="internship-introduction-section">
      <div className="internship-introduction-inner">
      <header className="internship-introduction-copy">
        <p className="section-eyebrow">START YOUR JOURNEY</p>
        <h1>Introduction</h1>
        <div className="internship-title-line" aria-hidden="true" />
        <p>
          The NCGSA Summer Internship Program, at Institute of Space Technology (IST), Islamabad
          is an annual, hands-on learning opportunity for students passionate about space science
          and technology. The program immerses participants in cutting-edge domains of Space
          Science and Technology, equipping them with essential skills and exposure to support
          their future careers in the space sector.
        </p>
      </header>

        <div className="internship-introduction-carousel" aria-label="NCGSA internship program gallery">
          <figure>
            <img
              key={introductionImages[currentImage]}
              src={introductionImages[currentImage]}
              alt={`NCGSA Summer Internship Program activity ${currentImage + 1}`}
            />
          </figure>
          <button
            type="button"
            className="internship-intro-arrow previous"
            aria-label="Show previous image"
            onClick={() => setCurrentImage((current) => (current - 1 + introductionImages.length) % introductionImages.length)}
          >‹</button>
          <button
            type="button"
            className="internship-intro-arrow forward"
            aria-label="Show next image"
            onClick={() => setCurrentImage((current) => (current + 1) % introductionImages.length)}
          >›</button>
          <div className="internship-intro-dots">
            {introductionImages.map((image, index) => (
              <button
                type="button"
                key={image}
                className={index === currentImage ? 'active' : ''}
                aria-label={`Show internship image ${index + 1}`}
                onClick={() => setCurrentImage(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroductionComponent;
